// ** Initial State
const initialState = {
  // List
  data: [],
  total: 1,
  params: {},
  allData: [],

  // For store medical record
  notifyDelete: null,
  notifyFailedDelete: null,
  notifySuccessAdd: null,
  notifyFailedAdd: null,
  newlyAddedMedicalRecord: null,
  medicalRecordCreationData: null,
  selectedUnit: null,
  selectedDoctor: null,
  selectPatientMethod: null,
  newlyPatient: null,
  failedMessage: null,

  // Detail Page
  medicalRecordUnitData: null,
  medicalRecordEncounterData: null,
  notifyUpdateMedicalRecordEncounter: null,
  notifyFailedUpdateMedicalRecordEncounter: null,

  // CPPT
  createOrUpdateModeCPPT: 'CREATE',
  currentCPPT: null,
  newlyAddedCPPT: null,
  notifySuccessAddCPPT: null,
  notifyFailedAddCPPT: null,
  failedMessageAddCPPT: null,
  notifyDeleteCPPT: null,
  notifyFailedDeleteCPPT: null,
  notifyUpdateCPPT: null,
  notifyFailedUpdateCPPT: null,

  // Unit
  notifyUpdateMedicalRecordUnit: null,

  // History 
  medicalRecordHistories: [],

  // Transfer
  notifyTransferToNewUnit: null,
  notifyFailedTransferToNewUnit: null,
  newMedicalRecordEncounterUUID: null,
  newMedicalRecordEncounterUnitUUID: null,
 
  // Treatment
  createOrUpdateModeTreatment: 'CREATE',
  currentTreatment: null,
  newlyAddedTreatment: null,
  notifySuccessAddTreatment: null,
  notifyFailedAddTreatment: null,
  failedMessageAddTreatment: null,
  notifySuccessUpdateTreatment: null,
  notifyFailedUpdateTreatment: null,
  failedMessageUpdateTreatment: null,


  // Medicine
  createOrUpdateModeMedicine: 'CREATE',
  currentMedicine: null,
  newlyAddedMedicine: null,
  notifySuccessAddMedicine: null,
  notifyFailedAddMedicine: null,
  failedMessageAddMedicine: null,
  notifySuccessUpdateMedicine: null,
  notifyFailedUpdateMedicine: null,
  failedMessageUpdateMedicine: null,
  
  // Finish
  notifyFinishMedicalRecord: null,
  notifyFailedFinishMedicalRecord: null,

  // Billing
  billing: null,
  billingLoading: false,
  billingError: null,
  savedBilling: null,
  saveBillingLoading: false,
  saveBillingError: null,
  billingHistory: [],
  billingHistoryLoading: false,
  billingHistoryError: null,
  billingDetail: null,
  billingDetailLoading: false,
  billingDetailError: null
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_MEDICAL_RECORD':
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'DELETE_DATA_MEDICAL_RECORD':
      return { 
        ...state,
        notifyDelete: action.notifyDelete // <--- store it
      }
    case 'FAILED_DELETE_DATA_MEDICAL_RECORD':
      return { 
        ...state,
        notifyFailedDelete: action.notifyFailedDelete // <--- store it
      }
    case 'CLEAR_NOTIFY_DELETE_MEDICAL_RECORD':
      return { ...state, notifyDelete: null }
    case 'CLEAR_FAILED_NOTIFY_DELETE_MEDICAL_RECORD':
      return { ...state, notifyFailedDelete: null }
    case 'UPDATE_MEDICAL_RECORD_CREATION_DATA':    
    console.log('UPDATE_MEDICAL_RECORD_CREATION_DATA')  
    console.log(action)
      return { 
        ...state, 
        medicalRecordCreationData: {
          ...state.medicalRecordCreationData,
          ...action
        }
      }
    case 'UPDATE_PATIENT_FORM_DATA':      
      return { 
        ...state, 
        newlyPatient: {
          ...state.newlyPatient,
          ...action
        }
      }      
    case 'UPDATE_SELECTED_UNIT':
      return { 
        ...state,
        selectedUnit: action.unit 
      }
    case 'UPDATE_SELECTED_DOCTOR':
      return { 
        ...state,
        selectedDoctor: action.doctor
      }
    case 'SET_SELECTED_PATIENT_METHOD':
      return { 
        ...state,
        selectPatientMethod: action.selectPatientMethod
      }     
    case 'SUCCESS_ADD_MEDICAL_RECORD':
      return { 
        ...state,
        notifySuccessAdd: true, 
        newlyAddedMedicalRecord: action.newlyAddedMedicalRecord
      }   
    case 'FAILED_ADD_MEDICAL_RECORD':      
      return { 
        ...state,
        notifyFailedAdd: true,
        failedMessage: action.failedMessage
      }   
    case 'RESET_NOTIFY_ADD_MEDICAL_RECORD':
      return { 
        ...state,
        notifySuccessAdd: false, 
        notifyFailedAdd: false,
        failedMessage: null
      }   
    case 'GET_DETAIL_MEDICAL_RECORD_UNIT_DATA':
      return { 
        ...state,
        medicalRecordUnitData: action.medicalRecordUnitData        
      }
    case 'GET_DETAIL_MEDICAL_RECORD_ENCOUNTER_DATA':      
      return { 
        ...state,
        medicalRecordEncounterData: action.medicalRecordEncounterData        
      }
    case 'UPDATE_DATA_MEDICAL_RECORD_ENCOUNTER': {
      const patch = Object.fromEntries(
        Object.entries(action.medicalRecordEncounterData || {}).filter(([_, v]) => v !== undefined && v !== null && v !== '')
      )
      return {
        ...state,
        medicalRecordEncounterData: {
          ...state.medicalRecordEncounterData,
          ...patch
        },
        notifyUpdateMedicalRecordEncounter: action.notifyUpdateMedicalRecordEncounter
      }
    }
    case 'FAILED_UPDATE_DATA_MEDICAL_RECORD_ENCOUNTER':
      return {
        ...state,
        notifyFailedUpdateMedicalRecordEncounter: action.notifyFailedUpdateMedicalRecordEncounter
      }
    case 'CLEAR_DATA_MEDICAL_RECORD_ENCOUNTER_NOTIFICATION':
      return {
        ...state,
        notifyUpdateMedicalRecordEncounter: null,
        notifyFailedUpdateMedicalRecordEncounter: null
      }
    case 'UPDATE_CPPT_DATA_FORM': {      
      const { condition, observation, procedure, allergy, familyMemberHistories, ...rest } = action      
    
      return {
        ...state,
        currentCPPT: {
          ...state.currentCPPT,          
          condition: condition ? {
                ...state.currentCPPT?.condition,
                ...condition
              } : state.currentCPPT?.condition,
          observation: observation ? {
            ...state.currentCPPT?.observation,
            ...observation
          } : state.currentCPPT?.observation,            
          procedure: procedure ? {
            ...state.currentCPPT?.procedure,
            ...procedure
          } : state.currentCPPT?.procedure,  
          allergy: allergy ? {
            ...state.currentCPPT?.allergy,
            ...allergy
          } : state.currentCPPT?.allergy,   
          familyMemberHistories: familyMemberHistories ? familyMemberHistories : state.currentCPPT?.familyMemberHistories,   
          ...rest
        }
      }
    }   
    case 'SUCCESS_ADD_NEW_CPPT':
      return { 
        ...state,
        notifySuccessAddCPPT: true, 
        newlyAddedCPPT: action.newlyAddedCPPT
      }   
    case 'FAILED_ADD_NEW_CPPT':
      return { 
        ...state,
        notifyFailedAddCPPT: true,
        failedMessageAddCPPT: action.failedMessageAddCPPT
      }  
    case 'RESET_NOTIFY_ADD_CPPT':
      return { 
        ...state,
        currentCPPT: null,
        notifySuccessAddCPPT: false, 
        notifyFailedAddCPPT: false,
        failedMessageAddCPPT: null
      }    
    case 'SUCCESS_ADD_NEW_TREATMENT':
      return { 
        ...state,
        notifySuccessAddTreatment: true, 
        newlyAddedTreatment: action.newlyAddedTreatment
      }   
    case 'FAILED_ADD_NEW_TREATMENT':
      return { 
        ...state,
        notifyFailedAddTreatment: true,
        failedMessageAddTreatment: action.failedMessageAddTreatment
      }  
    case 'RESET_NOTIFY_ADD_TREATMENT':
      return { 
        ...state,
        currentTreatment: null,
        notifySuccessAddTreatment: false, 
        notifyFailedAddTreatment: false,
        failedMessageAddTreatment: null
      }    
    case 'GET_DATA_CPPTs':
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'DELETE_DATA_CPPT':
      return { 
        ...state,
        notifyDeleteCPPT: action.notifyDeleteCPPT
      }
    case 'FAILED_DELETE_DATA_CPPT':
      return { 
        ...state,
        notifyFailedDeleteCPPT: action.notifyFailedDeleteCPPT
      }
    case 'CLEAR_NOTIFY_DELETE_CPPT':
      return { ...state, notifyDeleteCPPT: null }
    case 'GET_DETAIL_DATA_CPPT':
      return { ...state, currentCPPT: action.currentCPPT }
    case 'UPDATE_MODE_CPPT_TO_CREATE':
      return { ...state, createOrUpdateModeCPPT: 'CREATE' }
    case 'UPDATE_MODE_CPPT_TO_UPDATE':
      return { 
        ...state, 
        currentCPPT: {
          ...state.currentCPPT,  
          medicalRecordEncounterUnitCPPTUUID: action.medicalRecordEncounterUnitCPPTUUID 
        }, 
        createOrUpdateModeCPPT: 'UPDATE' }
    case 'UPDATE_DATA_CPPT':
      console.log('UPDATE_DATA_CPPT on Reducer')       
      return { 
        ...state,
        notifyUpdateCPPT: action.notifyUpdateCPPT
      }
    case 'FAILED_UPDATE_DATA_CPPT':
      return { 
        ...state,
        notifyFailedUpdateCPPT: action.notifyFailedUpdateCPPT
      }
    case 'CLEAR_NOTIFY_UPDATE_CPPT':
      return { ...state, notifyUpdateCPPT: null, notifyFailedUpdateCPPT: null }
    case 'UPDATE_DATA_MEDICAL_RECORD_UNIT':      
      return { 
        ...state, 
        medicalRecordUnitData: {
          ...state.medicalRecordUnitData,
          ...action.medicalRecordUnitData
        },
        notifyUpdateMedicalRecordUnit: action.notifyUpdateMedicalRecordUnit
      }
    case 'CLEAR_DATA_MEDICAL_RECORD_UNIT_NOTIFICATION':
      return { 
        ...state,         
        notifyUpdateMedicalRecordUnit: null
      }
    case 'GET_MEDICAL_RECORD_HISTORIES':
      return { 
        ...state,         
        medicalRecordHistories: action.medicalRecordHistories
      }
    case 'TRANSFER_TO_NEW_UNIT': 
      return { 
        ...state,         
        notifyTransferToNewUnit: action.notifyTransferToNewUnit,
        newMedicalRecordEncounterUUID: action.newMedicalRecordEncounterUUID,
        newMedicalRecordEncounterUnitUUID: action.newMedicalRecordEncounterUnitUUID
      }
    case 'FAILED_TRANSFER_TO_NEW_UNIT':
      return { 
        ...state,         
        notifyFailedTransferToNewUnit: action.notifyFailedTransferToNewUnit
      }
    case 'CLEAR_TRANSFER_TO_NEW_UNIT': 
      return { 
        ...state,    
        notifyTransferToNewUnit: null,     
        notifyFailedTransferToNewUnit: null,
        newMedicalRecordEncounterUUID: null,
        newMedicalRecordEncounterUnitUUID: null
      }
    case 'UPDATE_MODE_TREATMENT_TO_CREATE':
      return { 
        ...state, 
        createOrUpdateModeTreatment: 'CREATE',
        currentTreatment: null
      }
    case 'UPDATE_MODE_TREATMENT_TO_UPDATE':     
      return { 
        ...state, 
        createOrUpdateModeTreatment: 'UPDATE',
        currentTreatment: {
          ...state.currentTreatment,  
          encounterTreatmentUUID: action.encounterTreatmentUUID 
        }        
      }
        
    case 'UPDATE_TREATMENT_DATA_FORM': {
      const { performer, reference, ...rest } = action
      return {
        ...state,
        currentTreatment: {
          ...state.currentTreatment,
          performer: performer ? { ...state.currentTreatment?.performer, ...performer } : state.currentTreatment?.performer,
          reference: reference ? { ...state.currentTreatment?.reference, ...reference } : state.currentTreatment?.reference,
          ...rest
        }
      }
    }
    case 'FINISH_MEDICAL_RECORD': 
      return { 
        ...state,    
        notifyFinishMedicalRecord: action.notifyFinishMedicalRecord
      }          
    case 'FAILED_FINISH_MEDICAL_RECORD':
      return { 
        ...state,    
        notifyFailedFinishMedicalRecord: action.notifyFailedFinishMedicalRecord
      }   
     case 'CLEAR_FINISH_MEDICAL_RECORD':
      return { 
        ...state,   
        notifyFinishMedicalRecord: null, 
        notifyFailedFinishMedicalRecord: null
      }    
    case 'GET_DETAIL_DATA_TREATMENT':
      return { ...state, currentTreatment: action.currentTreatment }     
    case 'SUCCESS_UPDATE_TREATMENT':
      return {
        ...state, 
        notifySuccessUpdateTreatment: true
      }
    case 'FAILED_UPDATE_TREATMENT':
      return {
        ...state, 
        notifyFailedUpdateTreatment: true
      }
    case 'CLEAR_UPDATE_TREATMENT':
      return {
        ...state, 
        notifySuccessUpdateTreatment: null,
        notifyFailedUpdateTreatment: null
      }

    case 'UPDATE_MODE_MEDICINE_TO_CREATE':
      return { 
        ...state, 
        createOrUpdateModeMedicine: 'CREATE',
        currentMedicine: null
      }
    case 'UPDATE_MODE_MEDICINE_TO_UPDATE':     
      return { 
        ...state, 
        createOrUpdateModeMedicine: 'UPDATE',
        currentMedicine: {
          ...state.currentMedicine,  
          encounterMedicineUUID: action.encounterMedicineUUID 
        }        
      }
       
    case 'UPDATE_MEDICINE_DATA_FORM': {
      const { reasons, ingredients, ...rest } = action
      return {
        ...state,
        currentMedicine: {
          ...state.currentMedicine,
          reasons: reasons ? { ...state.currentMedicine?.reasons, ...reasons } : state.currentMedicine?.reasons,
          ingredients: ingredients ? { ...state.currentMedicine?.ingredients, ...ingredients } : state.currentMedicine?.ingredients,
          ...rest
        }
      }
    }
    case 'SUCCESS_ADD_NEW_MEDICINE':
      return { 
        ...state,
        notifySuccessAddMedicine: true, 
        newlyAddedMedicine: action.newlyAddedMedicine
      }   
    case 'FAILED_ADD_NEW_MEDICINE':
      return { 
        ...state,
        notifyFailedAddMedicine: true,
        failedMessageAddMedicine: action.failedMessageAddMedicine
      }  

    case 'RESET_NOTIFY_ADD_MEDICINE':
      return { 
        ...state,
        currentMedicine: null,
        notifySuccessAddMedicine: false, 
        notifyFailedAddMedicine: false,
        failedMessageAddMedicine: null
      }
    case 'SUCCESS_UPDATE_MEDICINE':
      return {
        ...state, 
        notifySuccessUpdateMedicine: true
      }
    case 'FAILED_UPDATE_MEDICINE':
      return {
        ...state, 
        notifyFailedUpdateMedicine: true,
        failedMessageUpdateMedicine: action.failedMessageUpdateMedicine
      }
    case 'CLEAR_UPDATE_MEDICINE':
      return {
        ...state, 
        notifySuccessUpdateMedicine: null,
        notifyFailedUpdateMedicine: null,
        failedMessageUpdateMedicine: null
      }

    // ===== Billing reducer cases =====
    case 'GET_BILLING_REQUEST':
      return { ...state, billingLoading: true, billingError: null }
    case 'GET_BILLING_SUCCESS':
      return { ...state, billingLoading: false, billing: action.billing }
    case 'GET_BILLING_FAILURE':
      return { ...state, billingLoading: false, billingError: action.billingError }

    case 'SAVE_BILLING_REQUEST':
      return { ...state, saveBillingLoading: true, saveBillingError: null, savedBilling: null }
    case 'SAVE_BILLING_SUCCESS':
      return { ...state, saveBillingLoading: false, savedBilling: action.savedBilling }
    case 'SAVE_BILLING_FAILURE':
      return { ...state, saveBillingLoading: false, saveBillingError: action.saveBillingError }
    case 'CLEAR_SAVE_BILLING':
      return { ...state, savedBilling: null, saveBillingError: null }

    case 'GET_BILLING_HISTORY_REQUEST':
      return { ...state, billingHistoryLoading: true, billingHistoryError: null }
    case 'GET_BILLING_HISTORY_SUCCESS':
      return { 
        ...state, 
        billingHistoryLoading: false, 
        billingHistory: action.billingHistory,
        billingHistoryPagination: action.pagination || {}
      }
    case 'GET_BILLING_HISTORY_FAILURE':
      return { ...state, billingHistoryLoading: false, billingHistoryError: action.billingHistoryError }

    case 'GET_BILLING_DETAIL_REQUEST':
      return { ...state, billingDetailLoading: true, billingDetailError: null, billingDetail: null }
    case 'GET_BILLING_DETAIL_SUCCESS':
      return { ...state, billingDetailLoading: false, billingDetail: action.billingDetail }
    case 'GET_BILLING_DETAIL_FAILURE':
      return { ...state, billingDetailLoading: false, billingDetailError: action.billingDetailError }
    default:
      return state
  }
}

export default DataTablesReducer
